import { Button, Stack, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { setSelectedTab, setViewTabs } from '../../../reducer/strategyBuilder.reducer'
import { StrategyBuilderTab } from '../header'
import { memo, useCallback } from 'react'
import PlusIcon from '../../../assets/icons/PlusIcon'

const CustomStrategyView = () => {
    const dispatch = useDispatch()

    const handleBuildStrategyClick = useCallback(() => {
        dispatch(setSelectedTab(StrategyBuilderTab.OptionChain))
        dispatch(setViewTabs(true))
    }, [dispatch])

    return (
        <Stack direction={'row'} alignItems={'center'} gap={2} sx={{ padding: 2 }} justifyContent={"space-between"}>
            <Stack>
                <Typography variant="h6" sx={{ width: '-webkit-fill-available', lineHeight: '' }}>
                    {'Build Your Own Strategy'}
                </Typography>
                <Typography variant="body2" color={"text.secondary"}>
                    {'Choose legs from the option chain based on delta, volatility, margin, payout aligned with your unique market view.'}
                </Typography>
            </Stack>
            <Button
                id="build-strategy-button"
                data-event={'Build Strategy Clicked'}
                size={'medium'}
                sx={{ minWidth: 160 }}
                data-event-source={'build-custom-strategy-card'}
                variant="contained"
                color={'primary'}
                startIcon={<PlusIcon fontSize={'large'} />}
                onClick={handleBuildStrategyClick}
            >
                {'New Strategy'}
            </Button>
        </Stack>
    )
}

export default memo(CustomStrategyView)
